@if (isInitialized) {
    <div class="ws-flex-container-vertical ws-flex-auto">
        <div class="ws-section">
            <div class="ws-section__header">
                <h4 class="ws-section__header__title">
                    History Lookup
                </h4>
            </div>
        </div>
        <div style="display: flex;" class="ws-flex-container-horizontal ws-flex-align-items-center">
            <label style="margin-right: 10px;">Table:</label>
            <select
                #tableSelect
                class="form-select form-select-sm"
                style="width: auto"
                (change)="tableSelectionChanged(tableSelect.value)"
            >
                <option value="" [ngValue]="0" disabled selected>Select a Table...</option>
                @for (option of tableSelections; track option) {
                    <option [ngValue]="option.id"> {{ option.name }} </option>
                }
            </select>
        </div>

        @if (currentSelectedTableId && !!currentTableColumnSets && currentTableColumnSets.length > 0) {
            <div style="display: flex;" class="ws-flex-container-horizontal ws-flex-align-items-center">
                <label style="margin-right: 10px;">Column:</label>
                <select
                    #columnSelect
                    class="form-select form-select-sm"
                    style="width: auto"
                    (change)="columnSelectionChanged(columnSelect.value)"
                >
                    <!-- <option value="" [ngValue]="0" disabled selected>Select a Column...</option> -->
                    @for (option of currentTableColumnSets; track option) {
                        <option [ngValue]="option.setIndexedHistoryColumnId"> {{ option.setName }} </option>
                    }
                </select>

                @if (!!selectedColumnSet && selectedColumnSet.setColumns.length > 0)
                {
                    @for (column of selectedColumnSet.setColumns; track column; let i = $index) {
                        <label style="margin-left: 20px; margin-right: 5px;">{{column.columnName}}:</label>
                        <input
                            type="text"
                            class="form-control"
                            style="max-width: 100px"
                            [(ngModel)]="searchModel.columnIdValues[i]"
                            currencyMask
                            [options]="{
                                allowNegative: false,
                                prefix: '',
                                thousands: '',
                                precision: 0,
                            }"
                        />
                    }
                }
                <button type="button"
                        class="ace-btn btn-sm btn-primary"
                        style="margin-left: 15px;"
                        (click)="doSearch()"
                        [disabled]="!readyToSearch()"
                        position="bottom">
                    Search
                </button>
            </div>
        }
        <!-- <div style="display: flex;" class="ws-flex-container-horizontal ws-flex-align-items-center">
            <span>Table Selection: {{currentSelectedTableId}}</span>
            <span style="margin-left: 10px;">Column Selection: {{searchModel.indexedHistoryColumnId}}</span>
            @for (option of searchModel.columnIdValues; track option; let i = $index) {
                <span style="margin-left: 10px;">Column Value[{{i}}]: {{option}}</span>
            }
        </div> -->

        <div style="display: flex;" class="ws-flex-container-horizontal ws-flex-align-items-center">
            <label style="margin-top: 10px;">Search Results:</label>
        </div>
    </div>

        @if (currentIndexedHistoryTable) {
            @switch (currentIndexedHistoryTable.historyTableName) {
                @case ('AccountNumber') {
                    <history-lookup-account-number
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-account-number>
                }
                @case ('Address') {
                    <history-lookup-address
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-address>
                }
                @case ('ClientServiceResponsibility') {
                    <history-lookup-client-service-responsibility
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-client-service-responsibility>
                }
                @case ('Company') {
                    <history-lookup-company
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-company>
                }
                @case ('Contact') {
                    <history-lookup-contact
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-contact>
                }
                @case ('GLAccount') {
                    <history-lookup-gl-account
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-gl-account>
                }
                @case ('Parcel') {
                    <history-lookup-parcel
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-parcel>
                }
                @case ('ParcelAssessmentClass') {
                    <history-lookup-parcel-assessment-class
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-parcel-assessment-class>
                }
                @case ('ParcelCollector') {
                    <history-lookup-parcel-collector
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-parcel-collector>
                }
                @case ('ParcelCollectorPaymentOption') {
                    <history-lookup-parcel-collector-payment-option
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-parcel-collector-payment-option>
                }
                @case ('ParcelCollectorTaxAuthority') {
                    <history-lookup-parcel-collector-tax-authority
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-parcel-collector-tax-authority>
                }
                @case ('ParcelDescriptor') {
                    <history-lookup-parcel-descriptor
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-parcel-descriptor>
                }
                @case ('Site') {
                    <history-lookup-site
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-site>
                }
                @case ('SiteDescriptor') {
                    <history-lookup-site-descriptor
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-site-descriptor>
                }
                @case ('TaxAuthority') {
                    <history-lookup-tax-authority
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-tax-authority>
                }
                @case ('TaxRateArea') {
                    <history-lookup-tax-rate-area
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-tax-rate-area>
                }
                @case ('Transaction') {
                    <history-lookup-transaction
                        style="height: 100%;"
                        [triggerSearch$]="searchTrigger$">
                    </history-lookup-transaction>
                }
            }
        }
}
